import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Platforms from './Platforms';
import Games from './Games';
import Consoles from './Consoles';
import logo from './assets/archivelogo.png';
import GridView from './GridView';
import Stats from './Stats';
import Wanted from './Wanted';
import SteamLibrary from './SteamLibrary';

function AppRoutes() {
  const location = useLocation();

  return (
    <div key={location.pathname} className="route-fade-page">
      <Routes>
        <Route path="/" element={<Platforms />} />
        <Route path="/consoles" element={<Consoles />} />
        <Route path="/platforms/:platformId" element={<Games />} />
        <Route path="/platforms/grid/:platformId" element={<GridView />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/wanted" element={<Wanted />} />
        <Route path="/steam" element={<SteamLibrary />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <div className="main-body">
      <div className="logo-shimmer">
        <Link to="/">
            <img src={logo} alt="Logo" style={{ cursor: 'pointer',height:150 }} />
          </Link>
        </div>
        </div>
        <AppRoutes />
     
    </Router>
  );
}
